import React, { useEffect, useRef } from 'react';
import Highlighter, { HighlighterItem } from '../v2/Highlighter';
import { SourceIcon } from '../v2/DataIngestion';
import { CodeDisplaySimple } from '../ui/CodeDisplay';
import createGlobe from 'cobe';

const chatBubbleCode = `
npm i @mendable/search

<MendableChatBubble anon_key={ANON_KEY} />
`;
export default function BentoFeatures() {
  const canvasRef = useRef();

  useEffect(() => {
    let phi = 0;
    // @ts-ignore
    const globe = createGlobe(canvasRef.current, {
      devicePixelRatio: 2,
      width: 400 * 2,
      height: 400 * 2,
      phi: 0,
      theta: 0,
      dark: 1,
      diffuse: 1.2,
      mapSamples: 16000,
      mapBrightness: 6,
      baseColor: [0.3, 0.3, 0.3],
      markerColor: [0.0, 0.0, 0],
      glowColor: [0.52, 0.34, 0.95],
      markers: [
        // longitude latitude
        { location: [37.7595, -122.4367], size: 0.03 },
        { location: [40.7128, -74.006], size: 0.1 }
      ],
      onRender: (state:any) => {
        // Called on every animation frame.
        // `state` will be an empty object, return updated params.
        state.phi = phi;
        phi += 0.001;
      }
    });
    return () => {
      globe.destroy();
    };
  }, []);
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="pt-16 md:pt-32">
        {/* Section header */}
        <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
          <h2 className="text-2xl sm:text-4xl font-semibold bg-clip-text text-transparent bg-gradient-to-r from-slate-100/60 via-slate-100 to-slate-100/60 pb-4">
            Supercharge your business
            </h2>
          <p className=" text-gray-400 mt-1 sm:text-lg">
            Mendable's AI ensures your business save on operational costs, driving down your support ticket volume and increasing customer satisfaction.
          </p>
        </div>

        {/* Highlighted boxes */}
        <div className="relative pb-12 md:pb-20">
          {/* Grid */}
          <Highlighter className="grid md:grid-cols-12 md:grid-rows-2 gap-6 group">
            {/* Box #1 */}
            <div className="md:col-span-12 row-span-2" data-aos="fade-down">
              <HighlighterItem>
                <div className="relative h-full bg-gray-950 rounded-[inherit] z-20 overflow-hidden">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                    {/* Radial gradient */}
                    <div
                      className="absolute flex items-center justify-center bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2 pointer-events-none -z-10 h-full aspect-square"
                      aria-hidden="true"
                    >
                      <div className="absolute inset-0 translate-z-0 bg-purple-500 rounded-full blur-[120px] opacity-70" />
                      <div className="absolute w-1/4 h-1/4 translate-z-0 bg-purple-400 rounded-full blur-[40px]" />
                    </div>
                    {/* Text */}
                    <div className="md:max-w-[480px] shrink-0 order-1 md:order-none p-6  md:p-8 md:pr-0">
                      <div className="mb-5">
                        <div>
                          <h3 className="inline-flex text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-100/60 via-slate-100 to-slate-100/60 pb-1">
                            Answers from multiple data sources
                          </h3>
                          <p className="text-gray-400  mt-1">
                            Ingest data through a simple
                            online GUI and through our API. You can easily add,
                            modify, or delete different types of sources.
                          </p>
                        </div>
                      </div>
                      <div>
                        {/* <a
                          className="btn-sm text-slate-300 hover:text-white transition duration-150 ease-in-out group [background:linear-gradient(theme(colors.slate.900),_theme(colors.slate.900))_padding-box,_conic-gradient(theme(colors.slate.400),_theme(colors.slate.700)_25%,_theme(colors.slate.700)_75%,_theme(colors.slate.400)_100%)_border-box] relative before:absolute before:inset-0 before:bg-slate-800/30 before:rounded-full before:pointer-events-none"
                          href="#0"
                        >
                          <span className="relative inline-flex items-center">
                            Learn more{' '}
                            <span className="tracking-normal text-purple-500 group-hover:translate-x-0.5 transition-transform duration-150 ease-in-out ml-1">
                              -&gt;
                            </span>
                          </span>
                        </a> */}
                      </div>
                    </div>
                    {/* Image */}
                    <div className="hidden lg:flex  mx-auto  relative ">
                      <div className=" relative z-0 grid  sm:w-fit grid-cols-4   gap-4">
                        <SourceIcon id="medium" />
                        <SourceIcon id="upload" />

                        <SourceIcon id="confluence" />

                        <SourceIcon id="drive" />
                        <SourceIcon id="youtube" />

                        <SourceIcon id="slack" />
                        <SourceIcon id="website" />
                        <SourceIcon id="zendesk" />
                      </div>
                      {/* <Image className="absolute bottom-0 left-1/2 -translate-x-1/2 mx-auto max-w-none md:relative md:left-0{md}transla{}-x-0" src={FeatureImg01} width="504" height="400" alt="Feature 01" /> */}
                    </div>
                  </div>
                </div>
              </HighlighterItem>
            </div>
            {/* Box #2 */}
            <div className="md:col-span-6 md:row-span-1" data-aos="fade-down">
              <HighlighterItem>
                <div className="relative h-full bg-gray-950 rounded-[inherit] z-20 overflow-hidden">
                  <div className="flex flex-col">
                    {/* Radial gradient */}
                    <div
                      className="absolute flex items-center justify-center bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2 pointer-events-none -z-10 h-full aspect-square"
                      aria-hidden="true"
                    >
                      <div className="absolute inset-0 translate-z-0 bg-purple-500 rounded-full blur-[120px] opacity-70" />
                      <div className="absolute w-1/4 h-1/4 translate-z-0 bg-purple-400 rounded-full blur-[40px]" />
                    </div>
                    {/* Text */}
                    <div className="md:max-w-[480px] flex flex-col items-center justify-center shrink-0 order-1 md:order-none p-6  md:p-8 md:pr-0">
                      <div>
                        <h3 className="inline-flex text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-100/60 via-slate-100 to-slate-100/60 pb-1">
                        Interchangable models (GPT 4, Claude-2 +)
                        </h3>
                        <p className="text-gray-400 mt-1 ">
                        Customize the AI based on your company's needs. Add your own voice, tone and personality.
                        </p>
                        
                      </div>
                      
                    </div>
                    {/* Image */}
                    {/* <div className="relative w-full h-64 md:h-auto overflow-hidden md:pb-8">
                      <Image className="absolute bottom-0 left-1/2 -translate-x-1/2 mx-auto max-w-none md:max-w-full md:relative md:left-0 md:translate-x-0" src={FeatureImg02} width={536} height={230} alt="Feature 02" />
                    </div> */}
                  </div>
                </div>
              </HighlighterItem>
            </div>
            {/* Box #3 */}
            <div className="md:col-span-6 md:row-span-2" data-aos="fade-down">
              <HighlighterItem>
                <div className="relative h-full bg-gray-950 rounded-[inherit] z-20 overflow-hidden">
                  <div className="flex flex-col">
                    {/* Radial gradient */}
                    <div
                      className="absolute flex items-center justify-center bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2 pointer-events-none -z-10 h-full aspect-square"
                      aria-hidden="true"
                    >
                      <div className="absolute inset-0 translate-z-0 bg-purple-500 rounded-full blur-[120px] opacity-70" />
                      <div className="absolute w-1/4 h-1/4 translate-z-0 bg-purple-400 rounded-full blur-[40px]" />
                    </div>
                    {/* Text */}
                    <div className="relative md:max-w-[480px] h-[300px] shrink-0 order-1 md:order-none p-6  md:p-8 md:pr-0">
                      <div>
                        <h3 className="inline-flex z-10 text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-100/60 via-slate-100 to-slate-100/60 pb-1">
                          Deploy everywhere - in multiple languages
                        </h3>
                        <p className="text-gray-400 z-10  mt-1">
                          Mendable AI supports multiple langugages such as English, Spanish, Portuguese and 15+ more.
                        </p>
                        <canvas
                className="absolute -right-48 top-28 bottom-0 z-0"
                //@ts-ignore
                ref={canvasRef}
                style={{
                  width: 500,
                  height: 400,
                  maxWidth: '100%',
                  aspectRatio: 1
                }}
              />
                      </div>
                    </div>
                    {/* Image */}
                    {/* <div className="relative w-full h-64 md:h-auto overflow-hidden md:pb-8">
                      <Image className="absolute bottom-0 left-1/2 -translate-x-1/2 mx-auto max-w-none md:max-w-full md:relative md:left-0 md:translate-x-0" src={FeatureImg03} width={230} height={230} alt="Feature 03" />
                    </div> */}
                  </div>
                </div>
              </HighlighterItem>
            </div>
            
            <div className="md:col-span-6 md:row-span-2" data-aos="fade-down">
              <HighlighterItem>
                <div className="relative h-full bg-gray-950 rounded-[inherit] z-20 overflow-hidden">
                  <div className="flex flex-col">
                    {/* Radial gradient */}
                    <div
                      className="absolute flex items-center justify-center bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2 pointer-events-none -z-10 h-full aspect-square"
                      aria-hidden="true"
                    >
                      <div className="absolute inset-0 translate-z-0 bg-purple-500 rounded-full blur-[120px] opacity-50" />
                    </div>
                    {/* Text */}
                    <div className="md:max-w-[480px] shrink-0 order-1 md:order-none p-6  md:p-8 md:pr-0">
                      <div>
                        <h3 className="inline-flex text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-100/60 via-slate-100 to-slate-100/60 pb-1">
                          Implement quickly
                        </h3>
                        <p className="text-gray-400  mt-1">
                          Get up and running in minutes with our easy to use
                          React components and API.
                        </p>
                      </div>
                    </div>

                    <div className="hidden lg:flex px-8 pb-4 z-10">
                      <CodeDisplaySimple code={chatBubbleCode} />
                    </div>
                    {/* Image */}
                    {/* <div className="relative w-full h-64 md:h-auto overflow-hidden md:pb-8">
                      <Image className="absolute bottom-0 left-1/2 -translate-x-1/2 mx-auto max-w-none md:max-w-full md:relative md:left-0 md:translate-x-0" src={FeatureImg03} width={230} height={230} alt="Feature 03" />
                    </div> */}
                  </div>
                </div>
              </HighlighterItem>
              
            </div>
            
            <div className="md:col-span-6 md:row-span-2" data-aos="fade-down">
              <HighlighterItem>
                <div className="relative h-full bg-gray-950 rounded-[inherit] z-20 overflow-hidden">
                  <div className="flex flex-col">
                    {/* Radial gradient */}
                    <div
                      className="absolute flex items-center justify-center bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2 pointer-events-none -z-10 h-full aspect-square"
                      aria-hidden="true"
                    >
                      <div className="absolute inset-0 translate-z-0 bg-purple-500 rounded-full blur-[120px] opacity-50" />
                    </div>
                    {/* Text */}
                    <div className="md:max-w-[480px] shrink-0 order-1 md:order-none p-6  md:p-8 md:pr-0">
                      <div>
                        <h3 className="inline-flex text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-100/60 via-slate-100 to-slate-100/60 pb-1">
                        {/* Interchangable models (GPT 4, Claude-2 +) */}
                        Enhance User Satisfaction
                        </h3>
                        <p className="text-gray-400  mt-1">
                          {/* Customize the AI based on your needs. Add your own voice, tone and personality. */}
                          Drive brand loyaly, encouraging repeat business and
                          positive word-of-mouth.
                        </p>
                      </div>
                      <img src="/usecases/Group 507 (2).png" className='w-full h-40' />
                    </div>
                    {/* Image */}
                    {/* <div className="relative w-full h-64 md:h-auto overflow-hidden md:pb-8">
                      <Image className="absolute bottom-0 left-1/2 -translate-x-1/2 mx-auto max-w-none md:max-w-full md:relative md:left-0 md:translate-x-0" src={FeatureImg03} width={230} height={230} alt="Feature 03" />
                    </div> */}
                  </div>
                </div>
              </HighlighterItem>
            </div>
            <div className="md:col-span-6 md:row-span-1" data-aos="fade-down">
              <HighlighterItem>
                <div className="relative h-full bg-gray-950 rounded-[inherit] z-20 overflow-hidden">
                  <div className="flex flex-col">
                    {/* Radial gradient */}
                    <div
                      className="absolute flex items-center justify-center bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2 pointer-events-none -z-10 h-full aspect-square"
                      aria-hidden="true"
                    >
                      <div className="absolute inset-0 translate-z-0 bg-purple-500 rounded-full blur-[120px] opacity-70" />
                      <div className="absolute w-1/4 h-1/4 translate-z-0 bg-purple-400 rounded-full blur-[40px]" />
                    </div>
                    {/* Text */}
                    <div className="md:max-w-[480px] flex flex-col items-center justify-center shrink-0 order-1 md:order-none p-6  md:p-8 md:pr-0">
                      <div>
                        <h3 className="inline-flex text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-100/60 via-slate-100 to-slate-100/60 pb-1">
                        SSO, BYOK, White Label
                        </h3>
                        <p className="text-gray-400 mt-1 ">
                        Mendable is built with enterprise in mind. We offer SSO, BYOK, and other enterprise features.
                        </p>
                        
                      </div>
                      
                    </div>
                    {/* Image */}
                    {/* <div className="relative w-full h-64 md:h-auto overflow-hidden md:pb-8">
                      <Image className="absolute bottom-0 left-1/2 -translate-x-1/2 mx-auto max-w-none md:max-w-full md:relative md:left-0 md:translate-x-0" src={FeatureImg02} width={536} height={230} alt="Feature 02" />
                    </div> */}
                  </div>
                </div>
              </HighlighterItem>
            </div>
            
          </Highlighter>
        </div>
      </div>
    </div>
  );
}
